export const getFiltersParams = (selectedInputs) => {
	return selectedInputs.reduce((acc, item) => {
		if (item?.value) {
			acc[item.key] = item.value === 'Active' ? 1 : item.value === 'Inactive' ? 0 : item.value;
		}
		return acc;
	}, {});
};
